/**
 * UI constants shared across web and mobile
 */

/**
 * Standard toast notification durations (in milliseconds)
 */
export const TOAST_DURATIONS = {
  success: 3000,
  error: 4000,
  info: 3000,
  warning: 4000,
} as const;
